import React from "react";
import styles from "./tokens-not-found.module.scss";
import Image from "next/image";
import thinking from "@public/web-content/bless-thinking.png";
import { motion } from "framer-motion";
import classNames from "classnames";

type Props = {
  size: "small" | "large";
};

const TokensNotFound = ({ size }: Props) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={styles.tokensNotFoundContainer}
    >
      <div
        className={classNames(styles.image, size === "small" && styles.small)}
      >
        <Image src={thinking} alt="tokens-not-found" />
      </div>
      <div
        className={classNames(styles.text, size === "small" && styles.small)}
      >
        <p className={styles.header}>No tokens found...</p>
        <p className={styles.subheader}>
          It appears you don&apos;t have any tokens
        </p>
      </div>
    </motion.div>
  );
};

export default TokensNotFound;
